import { render } from "./Students.vue?vue&type=template&id=76cbe664&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"unassigned_students\":\"props\",\"assigned_students\":\"props\",\"display\":\"data\",\"addList\":\"data\",\"removeList\":\"data\",\"update\":\"options\",\"add\":\"options\",\"remove\":\"options\",\"showUnassignConfirmationModal\":\"options\",\"saveSelectedUsers\":\"options\",\"removeSelectedUsers\":\"options\",\"setDisplayMode\":\"options\"}"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "76cbe664"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76cbe664')) {
    api.reload('76cbe664', script)
  }
  
  module.hot.accept("./Students.vue?vue&type=template&id=76cbe664&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"unassigned_students\":\"props\",\"assigned_students\":\"props\",\"display\":\"data\",\"addList\":\"data\",\"removeList\":\"data\",\"update\":\"options\",\"add\":\"options\",\"remove\":\"options\",\"showUnassignConfirmationModal\":\"options\",\"saveSelectedUsers\":\"options\",\"removeSelectedUsers\":\"options\",\"setDisplayMode\":\"options\"}", () => {
    api.rerender('76cbe664', render)
  })

}

script.__file = "resources/js/Pages/Classrooms/Students.vue"

export default script